export class StyleDescription {
	id?: number;
	name?: string;

	constructor(init?: Partial<StyleDescription>) {
		Object.assign(this, init);
	}
}
